var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import createCasesApi from '../../services/api/createCasesApi';
import { generateUUID } from 'syf-js-utilities';
import formatAnswerPayload from './helpers/formatAnswerPayload';
import getAmountInDispute from './helpers/getAmountInDispute';
import getDisputeReason, { getOriginalDisputeReason } from './helpers/getDisputeReason';
var createCase = createAsyncThunk('cases/createCase', function (_arg, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c, accountId, operationId, apigeeURL, _d, transactionId, referenceNumber, transactionCode, transactionAmount, transactionDate, statementDate, userAnswers, duplicateTransactions, transactions, partialDisputeAmount, formatAmountInDispute, selectedDuplicateTransactions, disputeReason, casesPayload, _e, status_1, casesResponse, error_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _b = getState(), _c = _b.appConfig, accountId = _c.accountId, operationId = _c.operationId, apigeeURL = _b.mfeConfig.apigeeURL, _d = _b.transactionData, transactionId = _d.transactionId, referenceNumber = _d.referenceNumber, transactionCode = _d.transactionCode, transactionAmount = _d.transactionAmount, transactionDate = _d.transactionDate, statementDate = _d.statementDate, userAnswers = _b.userAnswers, duplicateTransactions = _b.questionnaire.duplicateTransactions, transactions = _b.allDisputes.transactions;
                    partialDisputeAmount = getAmountInDispute(userAnswers);
                    formatAmountInDispute = partialDisputeAmount
                        ? Number(partialDisputeAmount).toFixed(2)
                        : transactionAmount;
                    selectedDuplicateTransactions = duplicateTransactions
                        .filter(function (txn) { return txn.selected; })
                        .map(function (txn) {
                        var _a;
                        return ({
                            id: txn.transactionId,
                            operationId: generateUUID(),
                            amount: txn.transactionAmount,
                            amountInDispute: txn.transactionAmount,
                            transactionCode: transactionCode,
                            date: txn.transactionDate,
                            referenceNumber: referenceNumber,
                            statementDate: (_a = txn.statementDate) !== null && _a !== void 0 ? _a : '',
                            disputeReason: getDisputeReason(userAnswers),
                            questionnaire: formatAnswerPayload(userAnswers) // might need to change
                        });
                    });
                    disputeReason = getDisputeReason(userAnswers) ||
                        getOriginalDisputeReason(transactions, transactionId);
                    casesPayload = {
                        transactions: __spreadArray([
                            {
                                id: transactionId,
                                operationId: operationId,
                                amount: transactionAmount,
                                amountInDispute: formatAmountInDispute,
                                transactionCode: transactionCode,
                                date: transactionDate,
                                statementDate: statementDate !== null && statementDate !== void 0 ? statementDate : '',
                                referenceNumber: referenceNumber,
                                disputeReason: disputeReason,
                                questionnaire: formatAnswerPayload(userAnswers)
                            }
                        ], selectedDuplicateTransactions, true)
                    };
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createCasesApi.postCases({
                            accountId: accountId,
                            apiHost: apigeeURL,
                            casesPayload: casesPayload
                        })];
                case 2:
                    _e = _f.sent(), status_1 = _e.status, casesResponse = __rest(_e, ["status"]);
                    return [2 /*return*/, __assign(__assign({ status: "".concat(status_1) }, casesResponse), { disputeReason: disputeReason })];
                case 3:
                    error_1 = _f.sent();
                    return [2 /*return*/, rejectWithValue(error_1)];
                case 4: return [2 /*return*/];
            }
        });
    });
});
export default createCase;
//# sourceMappingURL=createCase.js.map